import { render } from "./App.vue?vue&type=template&id=992dd058"
const script = {}

import "./App.vue?vue&type=style&index=0&id=992dd058&lang=scss"
script.render = render

export default script